import axios from 'axios'
import { withInterceptors } from '@/rest/interceptors'

/*TODO: replace with base axios instance after API fix*/
const axiosInstance = withInterceptors(
  axios.create({
    baseURL: process.env.VUE_APP_DX_API_URL,
  })
)

/**
 * Creates an API interface for interacting with DX.
 */
const createDxApi = () => {
  return {
    /**
     * Fetch quote data.
     * @param {string} symbol - Ticker symbol.
     * @returns {Promise<QuoteData>} Quote data for provided ticker symbol.
     */
    quote: (symbol) => axiosInstance.get(`quote/${symbol}`),
    /**
     * Fetch trade data.
     * @param {string} symbols - Tickers comma separated.
     * @returns {Promise<{[symbol: string]: TradeData}>} Dictionary with key (symbol) and value as a trade data
     */
    trade: (symbols) => axiosInstance.get(`trade/${symbols}`),
  }
}

const dxApi = createDxApi()

export { dxApi }

/**
 * @typedef {BaseEventData & {
 *   bidTime: number,
 *   bidExchangeCode: string,
 *   bidPrice: number,
 *   bidSize: number,
 *   askTime: number,
 *   askExchangeCode: string,
 *   askPrice: number,
 *   askSize: number
 * }} QuoteData
 */

/**
 * @typedef {BaseEventData & {
 *   time: number,
 *   exchangeCode: string,
 *   price: number,
 *   change: number,
 *   size: number,
 *   dayId: number,
 *   dayVolume: number,
 *   dayTurnover: number,
 *   tickDirection: string,
 *   extendedTradingHours: boolean
 * }} TradeData
 */

/**
 * @typedef {Object} BaseEventData
 * @property {string} eventType - The type of the event.
 * @property {string} eventSymbol - The symbol for the event.
 * @property {number} eventTime - The timestamp of the event.
 * @property {number} sequence - The sequence number of the event.
 * @property {number} timeNanoPart - The nano-part of the event time.
 */
